// Common job titles for the Target Customer Profile suggestions dropdown.
// Not exhaustive — the field still accepts free text.
export const JOB_TITLES: string[] = [
  'CEO',
  'Founder',
  'Co-Founder',
  'President',
  'COO',
  'CFO',
  'CMO',
  'CRO',
  'CTO',
  'CIO',
  'VP Sales',
  'VP Marketing',
  'VP Operations',
  'VP Business Development',
  'Head of Sales',
  'Head of Marketing',
  'Head of Growth',
  'Head of Business Development',
  'Head of Revenue Operations',
  'Head of Customer Success',
  'Director of Sales',
  'Director of Marketing',
  'Director of Operations',
  'Sales Manager',
  'Sales Director',
  'Regional Sales Manager',
  'Account Executive',
  'Account Manager',
  'Business Development Manager',
  'Business Development Representative',
  'Marketing Manager',
  'Growth Manager',
  'Product Manager',
  'Operations Manager',
  'Customer Success Manager',
  'Procurement Manager',
  'IT Manager',
  'HR Manager',
  'General Manager',
  'Managing Director',
  'Owner',
]
